import { SearchTerritoryType } from 'generated/graphql'
import type { TranslateOptions } from 'lib/tolgee'
import type { TDatadogErrorLog } from 'utils/datadog/types'
import TOLGEE_GLOBALS from 'utils/tolgeeGlobals'

export const GET_COUNTRY_THEMES_LOG: TDatadogErrorLog = {
  from: 'modules/global-topic/theme-list-tab',
  name: 'Gets the global taxonomy themes',
  message: 'Failed to fetch the global taxonomy themes of the workspace country',
}

export const SEARCH_TERRITORY_TABLE_LOG: TDatadogErrorLog = {
  from: 'modules/global-topic/theme-list-tab',
  name: 'Searches the global taxonomy territories',
  message: 'Failed to search the global taxonomy territories of the workspace country',
}

export const SEARCH_RESULT_METRICS_LOG: TDatadogErrorLog = {
  from: 'modules/global-topic/theme-list-tab',
  name: 'Gets the metrics of a search result',
  message: 'Failed to fetch the metrics of a global taxonomy territory found by the search',
}

export const SEARCH_TERRITORY_OPTIONS_LOG: TDatadogErrorLog = {
  from: 'modules/global-topic/theme-list-tab',
  name: 'Suggests global taxonomy territories',
  message: 'Failed to fetch the territory suggestions for the typed search term',
}

export const SEARCH_URL_PARAM = 'search'

export const SEARCH_TERRITORY_TABLE_TAKE = 5

export const SEARCH_RESULT_METRICS_CONCURRENCY = 5

export const SEARCH_TERRITORY_TABLE_TYPES: SearchTerritoryType[] = [
  SearchTerritoryType.Theme,
  SearchTerritoryType.Segment,
  SearchTerritoryType.Subject,
  SearchTerritoryType.Entity,
]

export const SEARCH_RESULT_LEVEL_LABELS: Readonly<Record<string, TranslateOptions>> = {
  theme: TOLGEE_GLOBALS.theme,
  segment: TOLGEE_GLOBALS.segment,
  subject: TOLGEE_GLOBALS.subject,
  entity_query: TOLGEE_GLOBALS.entity,
  entity: TOLGEE_GLOBALS.entity,
}
